import CountUp from "react-countup";
import React, {useEffect, useState} from "react";
import {CloseCircleOutlined} from "@ant-design/icons";
import {Col, Divider, InputNumber, Row, Slider, Statistic, Tag, Typography} from "antd";

const {Text} = Typography;

export function DashboardTransportEmissions({
                                                isOpenTransportEmissions,
                                                setIsOpenTransportEmissions,
                                                setEmMainTrasport,
                                                data,
                                                setErrorTransportEmissions
                                            }) {

    const [motorcycle, setMotorcycle] = useState(0)
    const [motorcyclePer, setMotorcyclePer] = useState(0)
    const [automobile, setAutomobile] = useState(0)
    const [automobilePer, setAutomobilePer] = useState(0)
    const [total, setTotal] = useState(0)
    const [totalPer, setTotalPer] = useState(0)
    const [inboundSlider, setInboundSlider] = useState(0)
    const [inbound, setInbound] = useState(0)
    const [outboundSlider, setOutboundSlider] = useState(0)
    const [outbound, setOutbound] = useState(0)
    const [inboundarySlider, setInboundarySlider] = useState(0)
    const [inboundary, setInboundary] = useState(0)
    const [totTravelled, setTotTravelled] = useState(0)
    const [ratioMotorcycle, setRatioMotorcycle] = useState(0)
    const [effMotorcycle, setEffMotorcycle] = useState(0)
    const [ratioAutomobile, setRatioAutomobile] = useState(0)
    const [effAutomobile, setEffAutomobile] = useState(0)
    const [ratioCycling, setRatioCycling] = useState(0)
    const [ratioFoot, setRatioFoot] = useState(0)
    const [statusForm, setStatusForm] = useState('')
    const [sumForm, setSumForm] = useState(0)

    const marks = {
        '-100': '-100%',
        0: '0',
        100: '+100%',
    };

    const formatter = (value) => <CountUp end={value} separator=" " decimals={3}/>;

    function close() {
        setIsOpenTransportEmissions(false)
    }

    useEffect(() => {

        setTotTravelled(data.km_inbound + data.km_outbound_def + data.km_inboundary_def)

        setRatioMotorcycle(data.ratio_motorcycle)
        setEffMotorcycle(data.eff_motorcycle)
        setRatioAutomobile(data.ratio_automobile)
        setEffAutomobile(data.eff_automobile)
        setRatioCycling(data.ratio_cycling)
        setRatioFoot(data.ratio_foot)

        setInbound(data.km_inbound_def)
        setOutbound(data.km_outbound_def)
        setInboundary(data.km_inboundary_def)

        setInboundSlider(data.slider_inbound)
        setOutboundSlider(data.slider_outbound)
        setInboundarySlider(data.slider_inboundary)

    }, [data])

    useEffect(() => {

        setInbound(data.km_inbound_def * (1 + (inboundSlider / 100)))

    }, [inboundSlider])

    useEffect(() => {

        setOutbound(data.km_outbound_def * (1 + (outboundSlider / 100)))

    }, [outboundSlider])

    useEffect(() => {

        setInboundary(data.km_inboundary_def * (1 + (inboundarySlider / 100)))

    }, [inboundarySlider])

    useEffect(() => {

        setTotTravelled(inbound + outbound + inboundary)

    }, [inbound, outbound, inboundary])

    useEffect(() => {

        //const value = (totTravelled * ratioMotorcycle * effMotorcycle * data.em_fact_motorcycle) / 1000000
        const value = ( (totTravelled * ratioMotorcycle * data.em_fact_motorcycle * 365) / effMotorcycle ) / (1000000 * 100)

        setMotorcycle(value)
        setMotorcyclePer(((value / data.motorcycle_emissions * 100) - 100).toFixed(0))

    }, [totTravelled, ratioMotorcycle, effMotorcycle]);

    useEffect(() => {

        //const value = (totTravelled * ratioAutomobile * effAutomobile * data.em_fact_automobile) / 1000000
        const value = ( (totTravelled * ratioAutomobile * data.em_fact_automobile * 365) / effAutomobile ) / (1000000 * 100)

        
        setAutomobile(value)
        setAutomobilePer(((value / data.automobile_emissions * 100) - 100).toFixed(0))

    }, [totTravelled, ratioAutomobile, effAutomobile])

    useEffect(() => {

        const value = motorcycle + automobile
        setEmMainTrasport(value)
        setTotal(value)
        setTotalPer(((value / (data.motorcycle_emissions + data.automobile_emissions) * 100) - 100).toFixed(0))

    }, [motorcycle, automobile]);

    useEffect(() => {

        const value = Math.round((ratioMotorcycle + ratioAutomobile + ratioCycling + ratioFoot) * 100) / 100

        setSumForm(value)

        if (value === 100) {
            setStatusForm('')
            setErrorTransportEmissions(false)
        } else {
            setStatusForm('error')
            setErrorTransportEmissions(true)
        }

    }, [ratioMotorcycle, ratioAutomobile, ratioCycling, ratioFoot]);

    return (
        <div className="panelDashboardContainer"
             style={{
                 display: isOpenTransportEmissions ? 'block' : 'none'
             }}
        >
            <div className="panelDashboardTitleIcon"><CloseCircleOutlined onClick={() => close()}/></div>
            <div className="panelDashboardTitle">Estimated CO2 Transport Emissions</div>

            <div style={{
                padding: '20px 10px 0 10px',
                display: 'flex',
                justifyContent: 'space-evenly',
            }}>
                <div className="panelDashboardSumTrasp">
                    {motorcyclePer == 0 && <div style={{height: 22, width: 50}}></div>}
                    {motorcyclePer < 0 && <Tag color="success" style={{width: 50}}>{motorcyclePer} %</Tag>}
                    {motorcyclePer > 0 && <Tag color="error" style={{width: 50}}>{motorcyclePer} %</Tag>}
                    <Statistic
                        title={<span>Motorcycle<br/><small>MtCO2e/year</small></span>}
                        value={motorcycle} formatter={formatter}/>
                </div>
                <div className="panelDashboardSumTrasp">
                    {automobilePer == 0 && <div style={{height: 22, width: 50}}></div>}
                    {automobilePer < 0 && <Tag color="success" style={{width: 50}}>{automobilePer} %</Tag>}
                    {automobilePer > 0 && <Tag color="error" style={{width: 50}}>{automobilePer} %</Tag>}
                    <Statistic
                        title={<span>Automobile<br/><small>MtCO2e/year</small></span>}
                        value={automobile} formatter={formatter}/>
                </div>
                <div className="panelDashboardSumTrasp">
                    {totalPer == 0 && <div style={{height: 22, width: 50}}></div>}
                    {totalPer < 0 && <Tag color="success" style={{width: 50}}>{totalPer} %</Tag>}
                    {totalPer > 0 && <Tag color="error" style={{width: 50}}>{totalPer} %</Tag>}
                    <Statistic
                        title={<span>Total<br/><small>MtCO2e/year</small></span>}
                        value={total} formatter={formatter}/>
                </div>
            </div>

            <div style={{padding: '0px 20px'}}>
                <Divider orientation="left">Km travelled</Divider>
                <Row style={{
                    alignItems: 'center'
                }}>
                    <Col span={4}>Inbound</Col>
                    <Col span={1}></Col>
                    <Col span={12}><Slider
                        marks={marks} min={-100} max={100}
                        value={inboundSlider}
                        tooltip={{open: false}}
                        onChange={(value) => setInboundSlider(value)}/></Col>
                    <Col span={1}></Col>
                    <Col span={6} style={{textAlign: 'right', fontFamily: 'monospace', fontSize: '1.1em'}}>
                        <CountUp end={inbound} separator=" " duration={0.3}/>
                        <Text type="secondary" style={{fontSize: '0.8em'}}> km</Text>
                    </Col>
                </Row>
                <Row style={{
                    alignItems: 'center'
                }}>
                    <Col span={4}>Outbound</Col>
                    <Col span={1}></Col>
                    <Col span={12}><Slider
                        marks={marks} min={-100} max={100}
                        value={outboundSlider}
                        tooltip={{open: false}}
                        onChange={(value) => setOutboundSlider(value)}/></Col>
                    <Col span={1}></Col>
                    <Col span={6} style={{textAlign: 'right', fontFamily: 'monospace', fontSize: '1.1em'}}>
                        <CountUp end={outbound} separator=" " duration={0.3}/>
                        <Text type="secondary" style={{fontSize: '0.8em'}}> km</Text>
                    </Col>
                </Row>
                <Row style={{
                    alignItems: 'center'
                }}>
                    <Col span={4}>Inboundary</Col>
                    <Col span={1}></Col>
                    <Col span={12}><Slider
                        marks={marks} min={-100} max={100}
                        value={inboundarySlider}
                        tooltip={{open: false}}
                        onChange={(value) => setInboundarySlider(value)}/></Col>
                    <Col span={1}></Col>
                    <Col span={6} style={{textAlign: 'right', fontFamily: 'monospace', fontSize: '1.1em'}}>
                        <CountUp end={inboundary} separator=" " duration={0.3}/>
                        <Text type="secondary" style={{fontSize: '0.8em'}}> km</Text>
                    </Col>
                </Row>
                <Row style={{
                    height: 53,
                    alignItems: 'center'
                }}>
                    <Col span={4}><b>Total km travelled</b></Col>
                    <Col span={1}></Col>
                    <Col span={12}></Col>
                    <Col span={1}></Col>
                    <Col span={6} style={{
                        textAlign: 'right',
                        fontWeight: 'bold',
                        fontFamily: 'monospace',
                        fontSize: '1.1em'
                    }}>
                        <CountUp end={totTravelled} separator=" " duration={0.3}/>
                        <Text type="secondary" style={{fontSize: '0.8em'}}> km</Text>
                    </Col>
                </Row>

                <Divider orientation="left">Transport mode and efficiency</Divider>
                <Text type="secondary">the sum must be equal 100%</Text>
                <div style={{marginTop: 5}}></div>
                <Row>
                    <Col span={11}>
                        <InputNumber
                            status={statusForm}
                            min={0} max={100} precision={2}
                            addonBefore={<span className="dashboardInputBefore180">Motorcycle ratio</span>}
                            addonAfter="%"
                            value={ratioMotorcycle}
                            onChange={(value) => setRatioMotorcycle(value)}/>
                        <div style={{marginTop: 10}}></div>
                        <InputNumber
                            status={statusForm}
                            min={0} max={100} precision={2}
                            addonBefore={<span className="dashboardInputBefore180">Automobile Ratio</span>}
                            addonAfter="%"
                            value={ratioAutomobile}
                            onChange={(value) => setRatioAutomobile(value)}/>
                        <div style={{marginTop: 10}}></div>
                        <InputNumber
                            status={statusForm}
                            min={0} max={100} precision={2}
                            addonBefore={<span className="dashboardInputBefore180">Bicycle</span>}
                            addonAfter="%"
                            value={ratioCycling}
                            onChange={(value) => setRatioCycling(value)}/>
                        <div style={{marginTop: 10}}></div>
                        <InputNumber
                            status={statusForm}
                            min={0} max={100} precision={2}
                            addonBefore={<span className="dashboardInputBefore180">On Foot</span>}
                            addonAfter="%"
                            value={ratioFoot}
                            onChange={(value) => setRatioFoot(value)}/>
                        {statusForm === '' && <div style={{
                            marginTop: 10,
                            marginLeft: 145
                        }}><Tag color="success">correct</Tag> {sumForm} %</div>}
                        {statusForm !== '' && <div style={{
                            marginTop: 10,
                            marginLeft: 158,
                            color: '#ff4d4f'
                        }}><Tag color="error">error</Tag> {sumForm} % </div>}
                    </Col>
                    <Col span={2}></Col>
                    <Col span={11}>
                        <InputNumber
                            min={0.1} max={100} precision={2}
                            addonBefore={<span className="dashboardInputBefore180">Motorcycle efficiency</span>}
                            addonAfter="km/l"
                            value={effMotorcycle}
                            onChange={(value) => setEffMotorcycle(value)}/>
                        <div style={{marginTop: 10}}></div>
                        <InputNumber
                            min={0.1} max={100} precision={2}
                            addonBefore={<span className="dashboardInputBefore180">Automobile efficiency</span>}
                            addonAfter="km/l"
                            value={effAutomobile}
                            onChange={(value) => setEffAutomobile(value)}/>

                    </Col>
                </Row>

                <div style={{height: 15}}></div>
            </div>
        </div>
    )
}